<template>
    <div class="serverlogs-page">
        <div class="page-head">
            <div class="left">
                <h1>Server Log</h1>
            </div>

        </div>
        <ServerLogsList ref="ServerLogsList" />
    </div>
</template>

<script>
    import ServerLogsList from "@/components/ServerLogs/ServerLogsList";

    export default {
        name: "ServerLogs",
        components: {
            ServerLogsList,
        },

        methods: {

        },
        mounted() {}
    };
</script>

<style scoped></style>
